/* IBM Confidential
 *
 * OCO Source Materials
 *
 * IBM Cognos Products: ba-ui-toolkit
 * (C) Copyright IBM Corp. 2019
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U.S. Copyright Office.
 * NLS_ENCODING=UTF-8
 * NLS_MESSAGEFORMAT_NONE
 */

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Accordion as CarbonAccordion } from 'carbon';
import { propsUtils } from '@ba-ui-toolkit/utils';

const { sanitize, BaPropTypes } = propsUtils;

export default class Accordion extends Component {
	static propTypes = {
		/** Child element(s) inside the accordion */
		children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
		/** Custom class name(s) */
		className: PropTypes.string,
		/** Disables the accordion */
		disabled: BaPropTypes.deprecated(' is ignored and not applicable to carbon accordian'),
		/** Where to place the chevron icon */
		icon: PropTypes.oneOf(['left', 'right']),
	};

	static defaultProps = {
		icon: 'left',
	};

	render() {
		const { children, disabled, icon, ...others } = this.props;

		const align = icon === 'left' ? 'start' : 'end';

		return (
			<CarbonAccordion {...sanitize(others, Accordion)} align={align}>
				{children}
			</CarbonAccordion>
		);
	}
}
